import { render, staticRenderFns } from "./ReportsDashboard.vue?vue&type=template&id=226d7c81&scoped=true"
import script from "./ReportsDashboard.vue?vue&type=script&lang=js"
export * from "./ReportsDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReportsDashboard.vue?vue&type=style&index=0&id=226d7c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d7c81",
  null
  
)

export default component.exports